import { matchMediaType } from '../../../utils';
import type { GalleryMediaValue, MediaValue } from '../../types';
import type { FacebookResponseMediaItem } from '../types';

export const getFacebookMedia = ({
  type: derivedType,
  media,
  subattachments,
  url = '',
  title = '',
  description = ''
}: Partial<FacebookResponseMediaItem>): MediaValue | undefined => {
  const type = matchMediaType(derivedType);

  const imageSrc = media?.image.src || '';

  if (type === 'gallery' && subattachments?.data.length) {
    return {
      type,
      items: subattachments.data.map(
        getFacebookMedia
      ) as GalleryMediaValue['items'],
      thumbnail: imageSrc || subattachments.data[0].media?.image?.src || ''
    };
  }

  if (type === 'image') {
    return {
      type,
      src: imageSrc
    };
  }

  if (type === 'video') {
    return {
      type,
      src: media?.source ?? url,
      thumbnail: imageSrc
    };
  }

  if (type === 'link') {
    if (media?.source) {
      return {
        type: 'video',
        src: media.source,
        thumbnail: imageSrc
      };
    }

    return {
      type,
      url,
      title,
      description,
      src: imageSrc
    };
  }

  return;
};
